import { Logo } from '../components/Logo';

export function LoadingScreen({ text = 'Preparing the martial world…' }: { text?: string }) {
  return (
    <main className="screen">
      <div className="loading" role="status" aria-live="polite">
        <Logo />
        <div className="spinner" />
        <div className="muted">{text}</div>
      </div>
    </main>
  );
}
